import React from 'react';
import './Footer.css';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="logo">
              <img src="/images/logo-light.png" alt="Logo light" className="logo-light" />   
            </div>
            <p>
              Soporte técnico, desarrollo de software y creación de sitios web adaptados a cada necesidad..
            </p>
          </div>
          <div className="footer-section">
            <h4>Enlaces Rápidos</h4>
            <ul>
              <li>
                <a href="#inicio" onClick={(e) => { e.preventDefault(); scrollToSection('inicio'); }}>
                  Inicio
                </a>
              </li>
              <li>
                <a href="#servicios" onClick={(e) => { e.preventDefault(); scrollToSection('servicios'); }}>
                  Servicios
                </a>
              </li>

              <li>
                <a href="#contacto" onClick={(e) => { e.preventDefault(); scrollToSection('contacto'); }}>
                  Contacto
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contacto</h4>
            <ul>
              <li>📧 consultas@blinkinformatica.com</li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Seguinos</h4>
            <div className="social-links">
             {/*  <a href="#" aria-label="Facebook">📘</a> */}
             <a href="https://www.instagram.com/blink.informatica" 
             aria-label="Facebook" 
             style={{ color: 'white', fontSize: '14px' }}
             
             >
              <img
                src="/images/instagram.svg"
                alt="Instagram"
                className="instagram-icon"
              />@blinkinformatica </a>
{/*               <a href="https://www.instagram.com/emilia.barrasmoviles" aria-label="Instagram">📷</a> */}
              {/* <a href="#" aria-label="Twitter">🐦</a> */}
            </div>
            <a
              href="https://wa.me/5491121848427"
              className="whatsapp-float"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Contactar por WhatsApp"
            >
              <img
                src="/images/whatsapp.svg"
                alt="WhatsApp"
              />
            </a>


          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Blink Informática. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
